"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localizedRangeValidatorErrorKeys = exports.LocalizedRangeValidatorErrorKey = exports.LocalizedRangeValidatorType = void 0;
/**
 * Localized Range Validator Types enum.
 */
var LocalizedRangeValidatorType;
(function (LocalizedRangeValidatorType) {
    LocalizedRangeValidatorType["GREATER_EQUAL_MIN_LESS_EQUAL_MAX"] = "GREATER_EQUAL_MIN_LESS_EQUAL_MAX";
    LocalizedRangeValidatorType["GREATER_EQUAL_MIN_LESS_MAX"] = "GREATER_EQUAL_MIN_LESS_MAX";
    LocalizedRangeValidatorType["GREATER_MIN_LESS_EQUAL_MAX"] = "GREATER_MIN_LESS_EQUAL_MAX";
    LocalizedRangeValidatorType["GREATER_MIN_LESS_MAX"] = "GREATER_MIN_LESS_MAX";
})(LocalizedRangeValidatorType = exports.LocalizedRangeValidatorType || (exports.LocalizedRangeValidatorType = {}));
/**
 * Localized Range Validator Error Keys enum.
 */
var LocalizedRangeValidatorErrorKey;
(function (LocalizedRangeValidatorErrorKey) {
    LocalizedRangeValidatorErrorKey["THRESHOLD_MIN"] = "LOCALIZED_RANGE_VALIDATOR_THRESHOLD_MIN";
    LocalizedRangeValidatorErrorKey["THRESHOLD_MAX"] = "LOCALIZED_RANGE_VALIDATOR_THRESHOLD_MAX";
    LocalizedRangeValidatorErrorKey["REQUIRED"] = "LOCALIZED_RANGE_VALIDATOR_REQUIRED";
    LocalizedRangeValidatorErrorKey["PARSE"] = "LOCALIZED_RANGE_VALIDATOR_PARSE";
})(LocalizedRangeValidatorErrorKey = exports.LocalizedRangeValidatorErrorKey || (exports.LocalizedRangeValidatorErrorKey = {}));
/**
 * An Array of the Localized Range Validator Error Keys.
 */
exports.localizedRangeValidatorErrorKeys = Object.keys(LocalizedRangeValidatorErrorKey).map((key) => LocalizedRangeValidatorErrorKey[key]);
//# sourceMappingURL=LocalizedRangeValidatorFn.js.map